import React, { useEffect, useRef, useState } from "react";
import { Eraser } from "lucide-react";

// Finger or mouse. The pad hands back a PNG data URL the moment a stroke ends.
export const SignaturePad = ({ onChange, testId = "signature-pad", height = 120 }) => {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [signed, setSigned] = useState(false);

  useEffect(() => {
    const c = canvasRef.current;
    if (!c) return;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio;
    c.height = height * ratio;
    const ctx = c.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#0f172a";
  }, [height]);

  const point = (e) => {
    const r = canvasRef.current.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  };

  const start = (e) => {
    e.preventDefault();
    drawing.current = true;
    const ctx = canvasRef.current.getContext("2d");
    const p = point(e);
    ctx.beginPath();
    ctx.moveTo(p.x, p.y);
  };

  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext("2d");
    const p = point(e);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
  };

  const end = () => {
    if (!drawing.current) return;
    drawing.current = false;
    setSigned(true);
    onChange?.(canvasRef.current.toDataURL("image/png"));
  };

  const clear = () => {
    const c = canvasRef.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    setSigned(false);
    onChange?.("");
  };

  return (
    <div className="space-y-1">
      <canvas ref={canvasRef} data-testid={testId}
              style={{ height, touchAction: "none" }}
              className="w-full rounded border border-dashed border-gray-300 bg-white cursor-crosshair"
              onPointerDown={start} onPointerMove={move} onPointerUp={end} onPointerLeave={end} />
      <div className="flex items-center gap-2 text-[10px] text-gray-500">
        <span>{signed ? "Signed" : "Sign above with a finger or the mouse"}</span>
        <button type="button" onClick={clear} data-testid={`${testId}-clear`}
                className="ml-auto inline-flex items-center gap-1 underline">
          <Eraser className="w-3 h-3" /> Clear
        </button>
      </div>
    </div>
  );
};

export default SignaturePad;
